import React from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import {
  CardElement,
  injectStripe,
  Elements,
  StripeProvider,
} from "react-stripe-elements";
import { Modal } from "reactstrap";
import AddressPickerModal from "./components/AddressPickerModal";
import WarningMessage from "./components/WarningMessage";
import MetaTags from "react-meta-tags";
import { apiLoggerPayment } from "./api/public";

/* eslint-disable import/no-webpack-loader-syntax */

import CartStyles from "./Cart.css";
import CartItem from "./components/CartItem";
import CartModalStyles from "./components/CartModal.css";
import CloseIcon from "-!svg-react-loader!./icons/close.svg";

import utilities from "./components/Utilities";
import calculator from "./components/PriceCalculator";

let Utilities = new utilities();
let Calculator = new calculator();

global.cartItems = {};
global.checkoutItems = {};
global.checkoutDeliveryAddress = {};
global.checkoutBillinAddress = {};

class Cart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      checkoutModal: false,
      addressPickerModal: false,
      addresses: [],
      billingAddress: null,
      deliveryAddress: null,
      addressPickerModalCurrent: null,
      loggedIn: false,
      items: [],
      definitons: {},
      prices: {},
      codeDiscount: 0,
      codeFailed: false,
      dicountValue: "",
      discountCode: "",
      isUser: false,
      showLoginMessage: false,
    };
  }

  componentDidMount() {
    document.title =
      window.globalVars.pageTitleBefore +
      "Cart" +
      window.globalVars.pageTitleAfter;
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    setTimeout(
      function () {
        let cart = JSON.parse(localStorage.getItem("cart"));
        let cartItems = [];

        if (Utilities.isENU(cart)) {
          cart = [];
        }

        for (let i = 0; i < cart.length; i++) {
          let cartItem = JSON.parse(localStorage.getItem(cart[i]));

          if (!Utilities.isENU(cartItem) && cartItem.addeddToCart) {
            cartItems.push(cartItem);
          } else {
            localStorage.removeItem(cart[i]);
            cart.splice(i, 1);
            i--;
          }
        }

        localStorage.setItem("cart", JSON.stringify(cart));

        console.log("CART ITEMS", cartItems);

        this.setState({
          items: cartItems,
        });

        global.checkoutItems = cartItems;

        let user = JSON.parse(localStorage.getItem("user"));

        !user
          ? this.setState({ isUser: false })
          : this.setState({ isUser: true });

        if (!Utilities.isENU(user)) {
          window.globalVars.server.api({
            method: "get",
            url: "/api/user/" + user._id,
            data: {},
            then: function (res) {
              if (!Utilities.isENU(res.data.data.addresses)) {
                let billing = null;
                let delivery = null;

                for (let i = 0; i < res.data.data.addresses.length; i++) {
                  let adr = res.data.data.addresses[i];
                  if (adr.type === "billing") {
                    billing = res.data.data.addresses[i];
                  } else if (adr.type === "delivery") {
                    delivery = res.data.data.addresses[i];
                  }
                }

                this.setState({
                  addresses: res.data.data.addresses,
                  billingAddress: billing || res.data.data.addresses[0],
                  deliveryAddress: delivery || res.data.data.addresses[0],
                  loggedIn: true,
                });

                global.checkoutBillinAddress =
                  billing || res.data.data.addresses[0];
                global.checkoutDeliveryAddress =
                  delivery || res.data.data.addresses[0];
              } else {
                this.setState({
                  loggedIn: false,
                });
              }
            }.bind(this),
            catch: function (e) {
              this.setState({
                loggedIn: false,
              });
            }.bind(this),
          });
        }
      }.bind(this),
      200
    );

    let defintions = window.globalVars.definitons;
    let defintionsAssociative = {};

    if (!Utilities.isENU(defintions)) {
      for (var i = 0; i < defintions.length; i++) {
        let type = defintions[i].type;
        if (["cart-message"].indexOf(type) !== -1) {
          defintionsAssociative[type] = defintions[i].valueStr;
        }
      }
    }

    this.setState({
      definitons: defintionsAssociative,
    });
  }

  toggleCheckoutModal = () => {
    this.setState({
      checkoutModal: !this.state.checkoutModal,
    });
  };

  toggleAddressPicker = (type) => {
    this.setState({
      addressPickerModal: true,
      addressPickerModalCurrent: type,
    });
  };

  checkIfCodeIsAvailable = (e) => {
    e.preventDefault();
    window.globalVars.server.api({
      method: "post",
      url: "/api/user/coupon_code",
      data: { codeName: this.state.discountCode },
      then: function (res) {
        console.log(res);
        if (res.data.code === "no-code-available")
          this.setState({ codeFailed: true, codeDiscount: 0 });
        else
          this.setState({
            codeFailed: false,
            codeDiscount: res.data.code.percent_off,
          });
      }.bind(this),
      catch: function (e) {
        this.setState({ codeFailed: true, codeDiscount: 0 });
        console.log(e);
      }.bind(this),
    });
  };

  updateQuanitity = (cartItemId, value) => {
    let cartItem = JSON.parse(localStorage.getItem(cartItemId));
    cartItem.quantity = value;
    localStorage.setItem(cartItemId, JSON.stringify(cartItem));

    let items = [...this.state.items];

    for (let i = 0; i < items.length; i++) {
      if (items[i].localId === cartItemId) {
        items[i].quantity = parseInt(value);
      }
    }

    this.setState(
      {
        items: items,
      },
      function () {
        this.forceUpdate();
      }
    );

    this.updateTotalPrice();
  };

  updateCartItemPrice = (localId, value) => {
    global.cartItems[localId] = parseFloat(value);
    // Setting price for db

    for (let i = 0; i < global.checkoutItems.length; i++) {
      if (global.checkoutItems[i].localId === localId) {
        global.checkoutItems[i].price = parseFloat(value);
      }
    }

    this.updateTotalPrice();
  };

  updateAddress = (type, address) => {
    if (type === "delivery") {
      this.setState({
        deliveryAddress: address,
        addressPickerModal: false,
      });
      global.checkoutDeliveryAddress = address;
    } else if (type === "billing") {
      this.setState({
        billingAddress: address,
        addressPickerModal: false,
      });
      global.checkoutBillinAddress = address;
    }
  };

  updateTotalPrice = () => {
    let total = 0;
    let tax = Calculator.definitions.filter((item) => item.type === "tax")[0]
      .value;

    for (let key in global.cartItems) {
      total += global.cartItems[key];
    }

    total = total * (1 + tax / 100);

    let node = document.getElementById("total-price");
    let nodePreDiscount = document.getElementById("total-price-pre-discount");
    let discountValue = document.getElementById("discount-value");
    let discountPercentage = document.getElementById("discount-percentage");

    if (node !== null) {
      const num = parseInt(total.toFixed(2));

      const numMinusDiscount = num * (1 - this.state.codeDiscount / 100);

      discountPercentage.innerHTML = this.state.codeDiscount.toString();

      const dicountValue = num - numMinusDiscount;

      node.innerHTML = window.currency + numMinusDiscount.toFixed(2);

      discountValue.innerHTML = dicountValue.toFixed(2);

      nodePreDiscount.innerHTML = window.currency + num;
    }

    let totalQuantity = 0;

    for (let i = 0; i < this.state.items.length; i++) {
      totalQuantity += parseInt(this.state.items[i].quantity);
    }

    node = document.getElementById("total-quantity");

    if (node !== null) {
      node.innerHTML = totalQuantity;
    }
  };

  toggleAddressPickerFromModal = () => {
    this.setState({
      addressPickerModal: !this.state.addressPickerModal,
    });
  };

  remove = (cartItemId) => {
    let cartItem = JSON.parse(localStorage.getItem(cartItemId));
    localStorage.removeItem(cartItemId);

    let cart = JSON.parse(localStorage.getItem("cart"));
    if (Utilities.isENU(cart)) {
      cart = [];
    }

    for (let i = 0; i < cart.length; i++) {
      if (cart[i] === cartItemId) {
        cart.splice(i, 1);
        break;
      }
    }

    // TODO do it without reload
    window.location.reload();

    // this.updateTotalPrice();
  };

  discountInput = (e) => {
    !this.state.isUser
      ? this.setState({ showLoginMessage: true })
      : this.setState({ discountCode: e.target.value });
  };

  render() {
    // pk_live_SuAM0hDnyMAf45jReH1aTCsW00QPXVT5Pv  pk_test_pqzLeoIJtLuQA2bGcL0dv52P

    return (
      <StripeProvider apiKey={window.stripeKey}>
        <div className="cart-container">
          <div className="navbar-background"></div>

          <MetaTags>
            <meta name="robots" content="noindex" />
            <meta name="googlebot" content="noindex" />
            <meta
              id="meta-description"
              name="description"
              content={
                window.region === "SG"
                  ? "Shopping cart for FrameIT Singapore."
                  : "Shopping cart for FrameIT Malaysia."
              }
            />
          </MetaTags>

          <div className="main-container">
            <div className="top">
              <h1>Cart</h1>
              {window.region === "SG" && (
                <p>
                  {this.state.definitons["cart-message"] ||
                    "Our workshop is now open after the circuit breaker period. Please note that our lead times may be slightly extended as a result of heavy demand at the moment."}
                </p>
              )}
              {window.region === "MY" && (
                <p>
                  Please note that our lead times may be slightly extended from
                  any impacts of COVID-19.
                </p>
              )}
            </div>
            <div className="cart" data-count={this.state.items.length}>
              <div className="left">
                {this.state.items.length === 0 ? (
                  <p className="no-results">Your cart is empty</p>
                ) : (
                  <div>
                    <div className="cart-items">
                      {this.state.items.map((item) => {
                        return (
                          <CartItem
                            updateQuanitity={(id, value) => {
                              this.updateQuanitity(id, value);
                            }}
                            onPriceUpdated={(localId, value) => {
                              this.updateCartItemPrice(localId, value);
                            }}
                            item={item}
                            remove={(id) => {
                              this.remove(id);
                            }}
                            item={item}
                            section="cart"
                          />
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
              {this.state.items.length !== 0 ? (
                <div className="right">
                  <div className="checkout-dialog">
                    <p
                      className="discount_text"
                      style={{ marginBottom: "5px" }}
                    >
                      Add a discount code
                    </p>

                    <form
                      className="discount_form"
                      onSubmit={(e) =>
                        this.state.discountCode.length > 0
                          ? this.checkIfCodeIsAvailable(e)
                          : e.preventDefault()
                      }
                    >
                      <input
                        onInput={(e) =>
                          // this.state.isUser &&
                          this.discountInput(e)
                        }
                        value={this.state.discountCode}
                        type="text"
                      />

                      <input
                        style={{
                          opacity: this.state.discountCode.length > 0 ? 1 : 0.6,
                        }}
                        className="submit_btn"
                        type="submit"
                      />
                    </form>
                    {!this.state.codeFailed && this.state.codeDiscount > 0 && (
                      <p className="discount_text discount_applied">
                        {this.state.codeDiscount}% discount applied
                      </p>
                    )}
                    {this.state.showLoginMessage && (
                      <p className="discount_text discount_applied">
                        Please login or register to apply discount
                      </p>
                    )}

                    {this.state.codeFailed && (
                      <h4 className="discount_text discount_applied">
                        This coupon is not valid
                      </h4>
                    )}
                    <h1>
                      Subtotal{" "}
                      <span>
                        <span id="total-quantity">0</span> items
                      </span>
                    </h1>
                    {Calculator.getTax() && (
                      <h2>Tax({Calculator.getTax()}%)</h2>
                    )}
                    <p id="total-price">Loading</p>
                    <p
                      id="total-price-pre-discount"
                      style={{ display: "none" }}
                    ></p>
                    <p id="discount-value" style={{ display: "none" }}></p>
                    <p id="discount-percentage" style={{ display: "none" }}></p>

                    {this.state.loggedIn ? (
                      <button onClick={() => this.toggleCheckoutModal()}>
                        Proceed to Payment
                      </button>
                    ) : (
                      <Link to="/login">Log In</Link>
                    )}
                  </div>
                  <div className="shipping-info">
                    Price includes shipping within {window.countryName}. For
                    international shipments, please contact us before ordering
                    your frames to get a shipping quote.
                  </div>
                </div>
              ) : null}
            </div>
            {this.state.addresses.length !== 0 &&
              this.state.items.length !== 0 && (
                <div className="addresses clearfix">
                  {window.region === "SG" && (
                    <div className="address">
                      <h3>Billing Address</h3>
                      <p>{this.state.billingAddress.address1}</p>
                      <p>{this.state.billingAddress.address2}</p>
                      <p>{this.state.billingAddress.address3}</p>
                      <button
                        onClick={() => {
                          this.toggleAddressPicker("billing");
                        }}
                      >
                        Change
                      </button>
                    </div>
                  )}
                  {window.region === "SG" && (
                    <div className="address">
                      <h3>Delivery Address</h3>
                      <p>{this.state.deliveryAddress.address1}</p>
                      <p>{this.state.deliveryAddress.address2}</p>
                      <p>{this.state.deliveryAddress.address3}</p>
                      <button
                        onClick={() => {
                          this.toggleAddressPicker("delivery");
                        }}
                      >
                        Change
                      </button>
                    </div>
                  )}
                  {window.region === "MY" && (
                    <div className="address">
                      <h3>Billing Address</h3>
                      <p>{this.state.billingAddress.address1My}</p>
                      <p>{this.state.billingAddress.address2My}</p>
                      <p>{this.state.billingAddress.cityMy}</p>
                      <p>{this.state.billingAddress.postalCodeMy}</p>
                      <p>{this.state.billingAddress.stateMy}</p>
                      <button
                        onClick={() => {
                          this.toggleAddressPicker("billing");
                        }}
                      >
                        Change
                      </button>
                    </div>
                  )}
                  {window.region === "MY" && (
                    <div className="address">
                      <h3>Delivery Address</h3>
                      <p>{this.state.deliveryAddress.address1My}</p>
                      <p>{this.state.deliveryAddress.address2My}</p>
                      <p>{this.state.deliveryAddress.cityMy}</p>
                      <p>{this.state.deliveryAddress.postalCodeMy}</p>
                      <p>{this.state.deliveryAddress.stateMy}</p>
                      <button
                        onClick={() => {
                          this.toggleAddressPicker("delivery");
                        }}
                      >
                        Change
                      </button>
                    </div>
                  )}
                </div>
              )}
          </div>
          <Modal
            isOpen={this.state.checkoutModal}
            toggle={this.toggleCheckoutModal}
            className="cart-modal"
          >
            <CloseIcon
              className="close-btn"
              onClick={() => {
                this.toggleCheckoutModal();
              }}
            />
            <div className="body">
              <h2>Checkout</h2>
              <Checkout
                items={this.state.items}
                deliveryAddress={this.state.deliveryAddress}
                billingAddress={this.state.billingAddress}
              />
            </div>
          </Modal>
          <AddressPickerModal
            open={this.state.addressPickerModal}
            toggle={() => {
              this.toggleAddressPickerFromModal();
            }}
            addresses={this.state.addresses || []}
            billingAddress={this.state.billingAddress}
            deliveryAddress={this.state.deliveryAddress}
            currentSelector={this.state.addressPickerModalCurrent}
            updateAddress={(type, address) => {
              this.updateAddress(type, address);
            }}
          />
        </div>
      </StripeProvider>
    );
  }
}

class CheckoutModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: "item", //null,
      billingAddress: null,
      deliveryAddress: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      items: nextProps.items,
      billingAddress: nextProps.billingAddress,
      deliveryAddress: nextProps.deliveryAddress,
    });
  }

  render() {
    return (
      <div className="Checkout">
        <Elements>
          <CardForm
            items={this.state.items}
            deliveryAddress={this.state.deliveryAddress}
            billingAddress={this.state.billingAddres}
          />
        </Elements>
      </div>
    );
  }
}

class _CardForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: null,
      billingAddress: null,
      deliveryAddress: null,
      status: null,
      buttonEnabled: true,
    };
  }

  disableButton = () => {
    this.setState({ buttonEnabled: false });
  };
  enableButton = () => {
    this.setState({ buttonEnabled: true });
  };

  async setLoggerPayment(error) {
    if(typeof error === 'object' && !!error) {
      const user = JSON.parse(localStorage.getItem("user")) ;
      const userEmail = typeof user === 'object' && !!user ? user.email : '';
      const message = typeof error === 'object' && !!error ? error.message : null;

      if(message) {
        await apiLoggerPayment(message, userEmail)
      }

    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      items: nextProps.items,
      billingAddress: nextProps.billingAddress,
      deliveryAddress: nextProps.deliveryAddress,
    });
  }

  async submit(ev) {
    if (ev.target.getAttribute("data-enabled") !== "true") {
      return;
    }

    this.disableButton();

    let { token, error } = await this.props.stripe.createToken({ name: "Name" });
    let price = document
      .getElementById("total-price-pre-discount")
      .innerHTML.trim();
    let discountValue = document
      .getElementById("discount-value")
      .innerHTML.trim();
    let discountPercentage = document
      .getElementById("discount-percentage")
      .innerHTML.trim();
    console.log("CHARGING: " + price);
    let tax = window.globalVars.tax;
    if (token === undefined) {
      this.setState({
        status: {
          success: false,
          message: "Invalid card data",
        },
      });

      this.enableButton();
      this.setLoggerPayment(error);
      return;
    }

    this.disableButton();

    window.globalVars.server.api({
      method: "post",
      url: "api/user/charge",
      data: {
        token: token.id,
        price: price,
        tax: tax,
        billingAddres: global.checkoutBillinAddress,
        deliveryAddress: global.checkoutDeliveryAddress,
        items: global.checkoutItems,
        codeDiscount: discountValue,
        discountPercentage: discountPercentage,
      },
      then: function (res) {
        if (res.data.success !== false) {
          localStorage.removeItem("cart");
          window.location.href = "/order/placed/" + res.data.id;
          // this.props.history.push("/order/placed/" + res.data.id)
        } else {
          if (res.data.data === "Price Match Error") {
            localStorage.removeItem("priceDefinitions");
            localStorage.removeItem("priceDefinitionsTimestmap");
            window.location.reload();
          } else {
            this.setState({
              status: {
                success: res.data.success,
                message: res.data.data,
              },
            });

            this.enableButton();
          }
        }
      }.bind(this),
      catch: function (e) {
        this.setState({
          status: {
            success: false,
            message: "Unexpected error",
          },
        });
        this.enableButton();
      }.bind(this),
    });
  }

  render() {
    return (
      <div className="checkout-form">
        <label>
          Enter your card details
          <CardElement style={{ base: { fontSize: "18px" } }} />
        </label>
        <WarningMessage
          message={this.state.status !== null ? this.state.status.message : ""}
        />
        <button
          data-enabled={this.state.buttonEnabled}
          className="final-checkout-btn"
          onClick={(e) => this.submit(e)}
        >
          Pay
        </button>
      </div>
    );
  }
}

const CardForm = injectStripe(_CardForm);

class Checkout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: "item", //null,
      billingAddress: null,
      deliveryAddress: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      items: nextProps.items,
      billingAddress: nextProps.billingAddress,
      deliveryAddress: nextProps.deliveryAddress,
    });
  }

  render() {
    return (
      <div className="Checkout">
        <Elements>
          <CardForm
            items={this.state.items}
            deliveryAddress={this.state.deliveryAddress}
            billingAddress={this.state.billingAddres}
          />
        </Elements>
      </div>
    );
  }
}

export default Cart;



// WEBPACK FOOTER //
// ./src/Cart.js